import React from 'react';
import { mockRoadmap } from '../mock';
import { CheckCircle2, Clock, Calendar } from 'lucide-react';

const Roadmap = () => {
  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return <CheckCircle2 className="w-6 h-6 text-[#00FFD1]" />;
      case 'in-progress':
        return <Clock className="w-6 h-6 text-[#FFD700]" />;
      default:
        return <Calendar className="w-6 h-6 text-[#4D4D4D]" />;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return '#00FFD1';
      case 'in-progress':
        return '#FFD700';
      default:
        return '#4D4D4D';
    }
  };

  return (
    <section id="roadmap" className="bg-black py-20">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="text-center mb-16">
          <h2 className="text-[48px] font-semibold leading-[1.1] tracking-[-0.02em] text-white mb-4">
            Development Roadmap
          </h2>
          <p className="text-[20px] font-medium leading-[1.5] text-[rgba(255,255,255,0.85)] max-w-2xl mx-auto">
            Our journey to revolutionize blockchain gaming
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {mockRoadmap.map((phase, index) => (
            <div
              key={index}
              className="border border-[rgba(255,255,255,0.25)] bg-[rgba(255,255,255,0.05)] p-8 hover:border-[#00FFD1] transition-all duration-400"
            >
              <div className="flex items-center justify-between mb-6">
                <span
                  className="text-[16px] font-semibold"
                  style={{ color: getStatusColor(phase.status) }}
                >
                  {phase.quarter}
                </span>
                {getStatusIcon(phase.status)}
              </div>

              <h3 className="text-[24px] font-semibold leading-[1.3] text-white mb-6">
                {phase.title}
              </h3>

              <ul className="space-y-3">
                {phase.items.map((item, itemIndex) => (
                  <li
                    key={itemIndex}
                    className="flex items-start gap-2 text-[16px] font-normal leading-[1.4] text-[rgba(255,255,255,0.85)]"
                  >
                    <span className="text-[#00FFD1] mt-1">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
